var render, staticRenderFns
import script from "./LotViewBiddingLive.vue?vue&type=script&lang=js&"
export * from "./LotViewBiddingLive.vue?vue&type=script&lang=js&"
import style0 from "./LotViewBiddingLive.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LotViewBiddingLive.vue?vue&type=style&index=1&id=55b82fae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b82fae",
  null
  
)

export default component.exports